<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de exame cadastrados">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/parametrizacao/relatorio-exame-cadastrado/List'

export default {
    components: {List},
}
</script>